// extracted by mini-css-extract-plugin
export var box = "Tag-module--box--a9cea";
export var box_md = "Tag-module--box_md--4d9cc";
export var box_xmd = "Tag-module--box_xmd--66a03";
export var box_flex = "Tag-module--box_flex--586d7";
export var box_lg = "Tag-module--box_lg--91eb9";
export var box_sm = "Tag-module--box_sm--fae17";
export var box_outer = "Tag-module--box_outer--ffebd";
export var box_whiteBg = "Tag-module--box_white-bg--f184b";
export var box_noMarginBottom = "Tag-module--box_no-margin-bottom--63f7b";
export var box_noPadding = "Tag-module--box_no-padding--03e47";
export var box_outerGray = "Tag-module--box_outer-gray--2e3ab";
export var box_dark = "Tag-module--box_dark--8d67e";
export var box_zIndex = "Tag-module--box_z-index--75f40";
export var box_zIndex6 = "Tag-module--box_z-index-6--131d7";
export var box_eventsWithLine = "Tag-module--box_events-with-line--e18ae";
export var box_featuresAo = "Tag-module--box_features-ao--02dfb";
export var box_verticalPaddings = "Tag-module--box_vertical-paddings--9e8f2";
export var clearP = "Tag-module--clearP--a47d6";
export var clearP_vc = "Tag-module--clearP_vc--28954";
export var filterTag = "Tag-module--filterTag--c585d";
export var noclose = "Tag-module--noclose--94931";
export var digest = "Tag-module--digest--781c4";
export var active = "Tag-module--active--20d48";
export var big = "Tag-module--big--62f9e";
export var translucent = "Tag-module--translucent--cf537";
export var mobile = "Tag-module--mobile--4768f";
export var desktopTablet = "Tag-module--desktop-tablet--099f4";
export var gray = "Tag-module--gray--62942";
export var rounded = "Tag-module--rounded--ba979";
export var numberMarker = "Tag-module--numberMarker--c1368";
export var fadeInAnimation = "Tag-module--fadeInAnimation--f2445";
export var placeHolderShimmer = "Tag-module--placeHolderShimmer--10de7";